<template>
  <div class="we-informational-card bg-white border-2 border-primary-brand-100 rounded-xl p-4 font-semibold text-sm text-primary-brand-300">
    
    <div v-if="hasDiscount" class="mb-4">
      <p>
        <span class="text-xl font-bold">{{ discount.code }}</span>
        <span class="mt-2">
          Valor mensal de <span class="font-bold">R$ {{selectedPlan.price.full_price}}</span> por <span class="font-bold">{{ discount.monthly_fees }} meses.</span><br>
          Fidelidade: <span class="font-bold">12 meses</span>
        </span>
      </p>
    </div>

    <p class="mb-2" v-html="informationCardText.general_information_details" />
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useStore } from 'vuex'

const store = useStore()

const selectedPlan = computed(() => store.getters.getSelectedPlan)

const informationCardText = computed(() => {
  return {
    general_information_details: selectedPlan.value.product?.general_information_details
  }
})

const session = ref();
const discount = computed(() => store.getters.getDiscount);
const hasDiscount = computed(() => Object.keys(discount.value).length > 0)


</script>